import { createStore } from 'vuex'
import globals from './modules/global' // keep your modules as-is

const store = createStore({
  modules: {
    globals, // namespaced module, same as before
  },
  state: {},
  getters: {},
  mutations: {},
  actions: {},
})

export default store
